<template>
  <div class="container" id="errorToast">
    <div :class="`content ${variant}`">
      <span class="message">{{ errorMessage }}</span>
      <button class="button times" @click="clearToast">
        <font-awesome-icon :class="`close-toast ${variant}`" :icon="['fas', 'times']" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, PropType, Ref } from 'vue';
import { useStore } from 'vuex';
import { ToastVariant } from '@/store/ui/types';

export default {
  name: 'Toast',
  props: {
    message: String,
    variant: {
      type: String as PropType<ToastVariant>,
      default: 'error',
    },
  },
  setup(props: { message: string }): { errorMessage: Ref<string>; clearToast: () => Promise<void> } {
    const store = useStore();
    const errorMessage: Ref<string> = computed(() => props.message);

    const clearToast = () => store.dispatch('ui/clearErrorMessage');

    return {
      errorMessage,
      clearToast,
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: fixed;
  width: 90%;
  top: 1rem;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 1;
}

.content {
  align-items: center;
  border-radius: 0.25rem;
  color: $white;
  display: flex;
  justify-content: center;
  margin: auto;
  max-width: 45rem;
  padding: 1rem 2.5rem 1rem 1rem;
  position: relative;

  &.error {
    background-color: $crimson-shade;
  }

  &.warn {
    color: $black;
    background-color: $secondary-shade;
  }

  &.info {
    background-color: $primary-shade;
  }

  .message {
  }

  .button {
    appearance: none;
    background: none;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 14px;
    padding: 6px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background 0.2s ease-in;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }

    .close-toast {
      color: white;
      height: 14px;
      width: 14px;

      &.warn {
        color: $black;
      }
    }
  }
}

.toast-enter-from,
.toast-leave-to {
  transform: translate(-50%, -100%);
}

.toast-enter-active,
.toast-leave-active {
  transition: all 150ms ease-in;
}

.toast-leave-from {
  transform: translate(-50%, 0);
}
</style>
